import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import React from "react";
import Button from "../../atoms/button/button.component.js";
import Card from "../../atoms/card/card.component.js";
import MergeUnit from "../merge-unit/merge-unit.component.js";
import {MergeHistoryCardContainer, MergeHistoryGridContainer} from "./merge-history-card.styles.js";
function MergeHistoryCard({
  mergeHistory,
  onUnmerge
}) {
  const {
    t
  } = useTranslation();
  return /* @__PURE__ */ React.createElement(MergeHistoryGridContainer, {
    item: true,
    md: 3,
    sm: 4,
    xs: 6
  }, /* @__PURE__ */ React.createElement(Card, {
    raised: false
  }, /* @__PURE__ */ React.createElement(MergeHistoryCardContainer, null, /* @__PURE__ */ React.createElement(MergeUnit, {
    source: mergeHistory.unit_src,
    destination: mergeHistory.unit_dst
  }), /* @__PURE__ */ React.createElement(Button, {
    onClick: () => onUnmerge(mergeHistory.id),
    variant: "outlined",
    color: "secondary"
  }, t("units.unmerge")))));
}
export default /* @__PURE__ */ React.memo(MergeHistoryCard);
